import { render, staticRenderFns } from "./CortinaComponents.vue?vue&type=template&id=2be4e194&"
import script from "./CortinaComponents.vue?vue&type=script&lang=js&"
export * from "./CortinaComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports